import React, { useState, useDispatch, useEffect } from 'reactn'
import { Divider, Flex, Input, Text, Box, Button } from '@chakra-ui/react'
import "./promo.css"

const Promo = ({ globalState }) => {
  const { store } = globalState
  const { ts, showPayment, calculating, promoCode, isFetchingCart } = store
  const setPromoCode = useDispatch("setPromoCode")
  const clearPromoCode = useDispatch("clearPromoCode")

  // Use store.promoCode as source of truth, fallback to ts.pc for display
  const appliedPromoCode = promoCode?.promo_code || (ts && ts.pc && ts.pc !== false && ts.pc !== "" ? ts.pc : "")

  const [code, setCode] = useState(appliedPromoCode || "")
  const [error, setError] = useState("")
  const [hasSubmitted, setHasSubmitted] = useState(false)
  const [isClearing, setIsClearing] = useState(false)

  const isFetching = isFetchingCart || calculating

  // If we're clearing, don't use appliedPromoCode to disable input
  const effectiveAppliedPromoCode = isClearing ? "" : appliedPromoCode

  useEffect(() => {
    if (calculating) {
      setError("")
    } else {
      // Update from ts.pc when it changes (from API response)
      // Only update if ts.pc has a valid value and it's different from current code
      if (ts && ts.pc && ts.pc !== false && ts.pc !== "" && code !== ts.pc) {
        setCode(ts.pc)
        setHasSubmitted(false) // Reset when valid code is applied
        setIsClearing(false) // Reset clearing flag when new code is applied
      }
      // If ts.pc is cleared (false or empty), reset clearing flag
      if (isClearing && ts && (ts.pc === false || ts.pc === "")) {
        setIsClearing(false)
      }
      // Only show error if we've submitted AND the API says it's invalid
      if (hasSubmitted && ts && ts.pc == false && code !== "") {
        setError("INVALID PROMO CODE")
      } else if (ts && ts.pc && ts.pc !== false && ts.pc !== "") {
        // Valid code applied - clear error
        setError("")
        setHasSubmitted(false)
      }
    }
  }, [ts.pc, calculating, code, hasSubmitted, isClearing])

  const onSubmit = (e) => {
    e.preventDefault()
    if (code.trim() === "" || isFetching) {
      return
    }
    setHasSubmitted(true)
    setError("") // Clear error while validating
    setPromoCode(code)
  }

  const setPCode = (code) => {
    if (code.length == 0) {
      clearCode()
    } else {
      setCode(code)
      // Clear error when user starts typing a new code
      setError("")
      setHasSubmitted(false)
    }
  }

  const clearCode = () => {
    setCode("") // Clear the typed code immediately
    setError("")
    setHasSubmitted(false)
    setIsClearing(true) // Set flag to allow input even if ts.pc hasn't updated yet
    clearPromoCode() // Clear from store
  }

  return (
    <Box id="promoCode" mt={1} mb={0}>
      <Divider mt={2} mb={2} />
      <Text mb="2px">
        {effectiveAppliedPromoCode ? "PROMO CODE APPLIED" : "PROMO CODE"}
      </Text>
      <form onSubmit={onSubmit}>
        <Flex id="promoflex">
          <Box flex="1" minHeight={"50px"}>
            <Input
              variant={"promocode"}
              ml={"0px !important"}
              mr={0}
              isDisabled={isFetching || !!effectiveAppliedPromoCode}
              onChange={(e) => setPCode(e.target.value)}
              value={code}
              autoComplete="off"
              id="code"
              name="code"
              label="PROMO CODE"
              placeholder="PROMO CODE"
              size="md"
              minHeight={"50px"}
            />
          </Box>
          <Box margin={"auto"}>
            {effectiveAppliedPromoCode ? (
              <Button
                variant={"voucher"}
                type={"button"}
                isDisabled={isFetching}
                onClick={() => clearCode()}
              >
                CLEAR
              </Button>
            ) : (
              <Button
                variant={"voucher"}
                isDisabled={isFetching}
                type={"submit"}
              >
                {isFetching ? "VALIDATING" : "APPLY"}
              </Button>
            )}
          </Box>
        </Flex>
        <Text minHeight={5}>{error}</Text>
      </form>
    </Box>
  )
}

export default Promo